'use client';

import React from 'react';

import {
    Align,
    Button,
    ButtonVariant,
    Column,
    Columns,
    Icon,
    IconName,
    IconSize,
    Modal,
    ModalBody,
    ModalFooter,
    Text,
    TextLevels,
    TrilogyColor,
    TypographyBold,
} from '@bytel/trilogy-react';

interface SmartChangeModalProps {
    isOpen: boolean;
    handleClose: () => void;
}

export function SmartChangeModal({ isOpen, handleClose }: Readonly<SmartChangeModalProps>) {
    return (
        <Modal active={isOpen} onClose={handleClose} title='En savoir plus sur Smart Change'>
            <ModalBody>
                <Columns mobile>
                    <Column narrow verticalAlign={Align.CENTER}>
                        <Icon
                            name={IconName.CREDIT_CARD_ACCEPTED}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </Column>
                    <Column verticalAlign={Align.CENTER}>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Paiement en douceur
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Déboursez un minimum aujourd&apos;hui et étalez le paiement de votre smartphone jusqu&apos;à
                            36 mois.
                        </Text>
                    </Column>
                </Columns>
                <Columns mobile>
                    <Column narrow verticalAlign={Align.CENTER}>
                        <Icon
                            name={IconName.FILE_EURO_CHECK_CIRCLE}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </Column>
                    <Column verticalAlign={Align.CENTER}>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Clôture de crédit simplifiée
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Dès 12 ou 24 mois, rendez votre téléphone pour clôturer votre crédit sans frais.
                        </Text>
                    </Column>
                </Columns>
                <Columns mobile>
                    <Column narrow verticalAlign={Align.CENTER}>
                        <Icon
                            name={IconName.MOBILE_RECOVERY}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </Column>
                    <Column verticalAlign={Align.CENTER}>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Reprise mobile garantie
                        </Text>
                        <Text level={TextLevels.TWO}>
                            On reprend votre téléphone tant qu&apos;il est en bon état, même avec des petites rayures.
                        </Text>
                    </Column>
                </Columns>
                <Columns mobile>
                    <Column narrow verticalAlign={Align.CENTER}>
                        <Icon
                            name={IconName.MOBILE_TOOLS}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </Column>
                    <Column verticalAlign={Align.CENTER}>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Bon plan réparation
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Une mauvaise chute&nbsp;? Bénéficiez de -30% sur la réparation de votre téléphone.
                        </Text>
                    </Column>
                </Columns>
                <Columns mobile>
                    <Column narrow verticalAlign={Align.CENTER}>
                        <Icon
                            name={IconName.SMART_CHANGE}
                            size={IconSize.MEDIUM}
                            circled
                            color={TrilogyColor.MAIN}
                            backgroundColor={TrilogyColor.MAIN_FADE}
                        />
                    </Column>
                    <Column verticalAlign={Align.CENTER}>
                        <Text level={TextLevels.TWO} typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD} marginless>
                            Et ensuite&nbsp;?
                        </Text>
                        <Text level={TextLevels.TWO}>
                            Choisissez votre nouveau téléphone et bénéficiez des avantages de Smart Change.
                        </Text>
                    </Column>
                </Columns>
            </ModalBody>
            <ModalFooter>
                <Button variant={ButtonVariant.PRIMARY} onClick={handleClose}>
                    Fermer
                </Button>
            </ModalFooter>
        </Modal>
    );
}
